<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-card style="min-height:450px;">
          <b-card-header> Issue info </b-card-header>
          <b-card-body style="font-size:1.3em">
            <div style="margin-bottom:8px">
              <span><b>Location:</b> {{ data[0].city }} </span>
            </div>
            <div style="margin-bottom:8px">
              <span><b>Company:</b> {{ data[0].company }} </span>
            </div>
            <div style="margin-bottom:8px">
              <span><b>Date: </b>{{ data[0].date }} </span>
            </div>
            <div style="margin-bottom:8px;">
              <span><b>Issue: </b>{{ data[0].issue }} </span>
            </div>
            <div style="margin-bottom:28px">
              <span
                ><b>Solved: </b>{{ data[0].solved == "Y" ? "Yes" : "No" }}
              </span>
            </div>
            <b-badge
              v-if="data[0].solved != 'Y'"
              :style="
                'background:' + data[0].urgency + ';display:block;marign:auto;'
              "
              >&nbsp;&nbsp;</b-badge
            >
            <b-badge v-else style="background:green ;display:block;marign:auto;"
              >&nbsp;&nbsp;</b-badge
            >
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card style="min-height:450px;">
          <b-card-header> Edit Issue </b-card-header>
          <b-card-body>
            <span style="color:lightgray;padding:3px">Issue Description</span>
            <b-form-textarea
              id="textarea"
              style="margin-bottom:10px"
              v-model="issue"
              placeholder="Issue"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <span style="color:lightgray;padding:3px">Select Urgency</span>
            <b-form-select
              v-model="urgency"
              :options="urgencyOptions"
              style="height:45px;"
              class="mb-2 selectlocation"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
            <b-button
              variant="outline-primary"
              @click="updateData()"
              style="display:block; margin: auto; margin-top:25px; width:80px"
              >Update</b-button
            >
            <hr />
            <b-button
              v-if="data[0].solved == 'N'"
              variant="outline-primary"
              @click="solve()"
              style="display:block; margin: auto; margin-top:25px; width:80px"
              >Solve</b-button
            >
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <!-- COMMENTS -->
      <b-col lg="12">
        <b-card>
          <b-card-header> Comments </b-card-header>
          <b-card-body style="font-size:1.3em">
            <template v-for="c in comments">
              <b-col lg="12" :key="c.id" style="padding: 5px;">
                <a
                  ><b>{{ c.user }}: </b> {{ c.comment }}</a
                >
              </b-col>
            </template>

            <b-form-textarea
              id="textarea"
              style="margin-bottom:10px; margin-top:30px"
              v-model="comment"
              placeholder="Add new comment"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <b-button
              variant="outline-primary"
              @click="sendComment()"
              style="display:block; margin: auto; margin-top:25px; width:80px"
              >Send</b-button
            >
          </b-card-body>
        </b-card>
      </b-col>
      <!-- FILES -->
      <b-col lg="12">
        <b-card>
          <b-card-header> Files </b-card-header>
          <b-card-body style="font-size:1.3em">
            <template v-for="c in filesOf" v-if="filesOf">
              <b-col lg="12" :key="c.id" style="padding: 5px;">
                <b>{{ c.user }} - </b>
                <a
                  :href="
                    fileUrl +
                      'tracker_private/uploads/fnsissues/' +
                      c.file
                  "
                >
                  {{ c.file }}</a
                >
              </b-col>
            </template>

            <b-form-file
              v-model="file"
              :state="Boolean(file)"
              style="margin-top:30px;"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>

            <b-button
              variant="outline-primary"
              @click="sendFile()"
              style="display:block; margin: auto; margin-top:25px; width:80px"
              >Send</b-button
            >
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  props: ["id"],
  data: function() {
    return {
      idParam: "",
      comment: "",
      comments: [],
      filesOf: [],
      file: [],
      data: [],
      urgency: "",
      urgencyOptions: [
        {
          value: "red",
          text: "High"
        },
        {
          value: "orange",
          text: "Medium"
        },
        {
          value: "yellow",
          text: "Low"
        }
      ],
      issue: "",
      fileUrl: process.env.VUE_APP_TRACKER_URL
    };
  },
  methods: {
    getComments() {
      let params = {};
      params = {
        id: this.idParam
      };
      this.$http.get("api/fns/issues/getComments.php", { params }).then(
        res => {
          this.comments = res.data;
          console.log(res);
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    getFiles() {
      let params = {};
      params = {
        id: this.idParam
      };
      this.$http.get("api/fns/issues/getFiles.php", { params }).then(
        res => {
          this.filesOf = res.data;
          console.log(res);
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    getData() {
      let params = {};
      params = {
        id: this.idParam
      };
      this.$http.get("api/fns/issues/issuePreview.php", { params }).then(
        res => {
          this.data = res.data;
          this.issue = this.data[0].issue;
          this.urgency = this.data[0].urgency;
          console.log(this.location);
          console.log(res);
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    updateData() {
      let formData = new FormData();
      formData.append("issue", this.issue);
      formData.append("urgency", this.urgency);
      formData.append("id", this.idParam);
      formData.append("user", localStorage.getItem("fns_full_name"));
      this.$http
        .post("api/fns/issues/editIssue.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(
          res => {
            console.log(res.data);
            this.getData();
          },
          err => {
            console.log(err);
          }
        );
    },
    solve() {
      let formData = new FormData();
      formData.append("solved", "Y");
      formData.append("id", this.idParam);
      formData.append("user", localStorage.getItem("fns_full_name"));
      this.$http
        .post("api/fns/issues/solvedIssue.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(
          res => {
            console.log(res.data);
            this.getData();
          },
          err => {
            console.log(err);
          }
        );
    },
    sendComment() {
      let formData = new FormData();
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;

      formData.append("date", dateTime);
      formData.append("comment", this.comment);
      formData.append("user", localStorage.getItem("fns_full_name"));
      formData.append("id", this.idParam);

      this.$http
        .post("api/fns/issues/sendComment.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(
          res => {
            console.log(res.data);
            this.comment = '';
            this.getComments();
          },
          err => {
            console.log(err);
          }
        );
    },
    sendFile() {
      let formData = new FormData();
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;

      formData.append("date", dateTime);
      formData.append("files", this.file);
      formData.append("user", localStorage.getItem("fns_full_name"));
      formData.append("id", this.idParam);

      this.$http
        .post("api/fns/issues/uploadFiles.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(
          res => {
            console.log(res.data);
            this.getFiles();
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchLocations() {
      this.$http.get("api/fns/profile/companyLocations.php", {}).then(
        res => {
          this.optionsLocation = res.data.records;
          console.log(res);
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    }
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    this.idParam = this.id;
    this.fetchLocations();
    this.getData();
    this.getComments();
    this.getFiles();
  }
};
</script>
<style>
.selectlocation {
  background: #515b65;
  border: 1px solid black;
  color: white;
}
</style>
